import axios from "axios";
import Cookies from "js-cookie";
import config from "../config/config";

const env = process.env.NODE_ENV;

const server = config[env];
const serverUrl = server?.serverUri;
const clientUrl = server?.clientUri;
 

export default class ApiServices {
  static async rawGetRequest(path) {
    try {
      const { res } = await axios.get(path);
      return res;
    } catch (error) {
      return await this.handleError(error);
    }
  }

  static async getRequestNoAuth(path) {
    axios.defaults.withCredentials = true;
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { res } = await axios.get(`${serverUrl}${path}`,config);
      return res;
    } catch (error) {
      return await this.handleError(error);
    }
  }

  static async postRequestNoAuth(path, postData) {
    axios.defaults.withCredentials = true;
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const res = await axios.post(`${serverUrl}${path}`, postData, config);
      return res.data;
    } catch (error) {
      return await this.handleError(error);
    }
  }

  static async getRequest(url) {
    axios.defaults.withCredentials = true;    
    try {
      const config = {
        headers: {         
          "Authorization": this.getLocalStorage("access-token"),
          "Content-Type": "application/json",
        },
      };            
      let response = await axios.get(`${serverUrl}${url}`, config);
      return response.data;
    } catch (error) {
      return this.handleError(error);
    }
  }

  static async postRequest(path, data) {
    axios.defaults.withCredentials = true;
  
    try {
      const isFormData = data instanceof FormData;
  
      const config = {
        headers: {
          "Authorization": this.getLocalStorage("access-token"),
          ...(isFormData
            ? {} 
            : { "Content-Type": "application/json" }),
        },
      };
  
      const response = await axios.post(
        `${serverUrl}${path}`,
        data,
        config
      );
      
      return response.data;
    } catch (error) {
      return await this.handleError(error);
    }
  }

  static async putRequest(path, data) {
    axios.defaults.withCredentials = true;
    try {
      const isFormData = data instanceof FormData;
  
      const config = {
        headers: {
          "Authorization": this.getLocalStorage("access-token"),
          ...(isFormData
            ? {} 
            : { "Content-Type": "application/json" }),
        },
      };
  
      const response = await axios.put(
        `${serverUrl}${path}`,
        data,
        config
      );
  
      return response.data;
    } catch (error) {
      return await this.handleError(error);
    }
  }

  static async deleteRequest(url, data) {
    axios.defaults.withCredentials = true;    
    try {
      const config = {
        headers: {
          "Authorization": this.getLocalStorage("access-token"),
          "Content-Type": "application/json",
        },
        data
      };
      let response = await axios.delete(`${serverUrl}${url}`, config);
      return response.data;
    } catch (error) {
      return await this.handleError(error);
    }
  }

  static getUserCookie = (name) => {
    const cookieValue = Cookies.get(name);
    if (cookieValue === undefined) return null;
    return JSON.parse(cookieValue);
  };

  static async checkLoginStatus() {
    try {
      const user = this.getCookie("user");
      if (!user) return null;
      if (user) {
        return JSON.parse(user);
      }
    } catch (error) {
      return await this.handleError(error);
    }
  }



  static setCookie = (key, item, period) => {
    Cookies.set(key, JSON.stringify(item), { expires: period });
  };

  static getCookie = (name) => {
    const cookieValue = Cookies.get(name);
    if (cookieValue === undefined) return null;
    return cookieValue;
  };

  static removeCookie = (name) => {
    Cookies.clear(name);
  };

  static clearCookie = (name) => {
    document.cookie.clear(name);
  };

  static setLocalStorage(key, item) {
    try {
      const ttlInMs = 6 * 60 * 60 * 1000 // 6hrs
      const now = new Date();
  
      const value = {
        data: item,
        expiry: now.getTime() + ttlInMs,
      };
  
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      this.handleError(error);
    }
  }
  static getLocalStorage(key) {
    try {
      const itemStr = localStorage.getItem(key);
      if (!itemStr) return null;
  
      const item = JSON.parse(itemStr);
      const now = new Date();
  
      if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }
  
      return item.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  static async checkAuth(query = 0) {
    try {
      let token = sessionStorage.getItem("accessToken");
      if (!token) return null;

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: query,
      };

      let response = await axios.get(`${serverUrl}/auth/checkauth`, config);
      return response.data;
    } catch (error) {
      await this.handleError(error);
    }
  }



  static removeLocalStorage(key) {
    try {
      const result = localStorage.removeItem(key);
      return result;
    } catch (error) {
      console.log(error);
    }
  }

  static setSessionStorage(key, item) {
    try {
      const result = sessionStorage.setItem(key, JSON.stringify(item));
      return result;
    } catch (error) {
      console.log(error);
    }
  }

  static getSessionStorage(key) {
    try {
      const result = JSON.parse(sessionStorage.getItem(key));
      return result;
    } catch (error) {
      console.log(error);
    }
  }

  static removeSessionStorage(key) {
    try {
      const result = sessionStorage.removeItem(key);
      return result;
    } catch (error) {
      console.log(error);
    }
  }

  static handleLogout() {
    Cookies.remove("access-token");
    Cookies.remove("authenticated");
    Cookies.remove("user");
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace(`${clientUrl}/`);
  }

  static handleError(error) {
    if (error.response) {
      return error.response.data;
    } else {
      return this.errorResponse(error.status, "Internal Server Error", null);
    }
  }

  static errorResponse(status, message, data) {
    return {
      success: false,
      status,
      message,
      data,
    };
  }
}
